import { getCore } from '../../../client/core/getCore';
import type { DynamicClient } from '../../../client/types';
import { emitEvent } from '../../clientEvents';

/**
 * Sets up bidirectional event synchronization between the core event emitter
 * and the CrossTabBroadcast service.
 *
 * This enables events fired in one tab to be received in other tabs.
 *
 * **Local → Cross-Tab (Forwarding)**
 * - Listens to specific events on core.eventEmitter
 * - Forwards them to other tabs via core.crossTabBroadcast.send()
 *
 * **Cross-Tab → Local (Receiving)**
 * - Listens to cross-tab events via core.crossTabBroadcast.on()
 * - Emits corresponding "*InAnotherTab" events on core.eventEmitter
 *
 * @param client - The Dynamic client instance
 */
export const setupCrossTabEventSync = (client: DynamicClient) => {
  const core = getCore(client);

  // === FORWARDING: Local events → Cross-Tab ===
  // Listen to deviceRegistrationCompleted and forward to other tabs
  const handleDeviceRegistrationCompleted = () => {
    core.crossTabBroadcast.send({ event: 'deviceRegistrationCompleted' });
  };

  core.eventEmitter.on(
    'deviceRegistrationCompleted',
    handleDeviceRegistrationCompleted
  );

  // === RECEIVING: Cross-Tab → Local events ===
  // Listen to cross-tab deviceRegistrationCompleted and emit local variant
  const handleCrossTabDeviceRegistrationCompleted = () => {
    emitEvent({ event: 'deviceRegistrationCompletedInAnotherTab' }, client);
  };

  core.crossTabBroadcast.on(
    'deviceRegistrationCompleted',
    handleCrossTabDeviceRegistrationCompleted
  );
};
